<template>
  <Modal v-model="visible" footer-hide :width="1000">
    <template #header>
      <p>变更日志</p>
    </template>

    <Row class="table-title p-t-5 p-b-5" :gutter="8">
        <i-col span="3">变更时间</i-col>
        <i-col span="3">变更项</i-col>
        <i-col span="18">变更内容</i-col>
    </Row>
    <Row v-for="(item,index) in changeLogData" :gutter="8" :key="index" class="p-t-5 p-b-5"  :class="(index%2 === 0)?'table-row-1':'table-row-2'">
        <i-col span="3">
          {{ item.createTime }}
        </i-col>
        <i-col span="3">
          {{ item.content }}
        </i-col>
        <i-col span="18">
          <span v-if="item.changeStr === '' || item.changeStr === '[]'">-</span>
          <template v-else>
            <p v-for="changeItem in JSON.parse(item.changeStr)" :key="changeItem.id">
              <span>计费类型：{{ changeItem.feeTypeName  }}</span>
              <span class="m-l-5"> {{ changeItem.startDate.year + '-' + changeItem.startDate.month + '-' + changeItem.startDate.day  }}</span>
              <span class="m-l-5"> {{ changeItem.endDate.year + '-' + changeItem.endDate.month + '-' + changeItem.endDate.day  }}</span>
              <span class="m-l-5">计费数量：{{ changeItem.number  }}</span>
              <span class="m-l-5">计费单价：{{ changeItem.signPrice }}</span>
              <span class="m-l-5">合计：{{ changeItem.totalPrice  }}</span>
            </p>
          </template>
        </i-col>
    </Row>
  </Modal>
</template>

<script>
import { listChangeLog } from '@/api/invest/contract'

export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,

      changeLogData: []
    }
  },
  methods: {
    showModal () {
      this.visible = true

      listChangeLog({ contractId: this.contractId }).then(res => {
        this.changeLogData = res
      })
    }
  },
  computed: {
    contractId () {
      return this.$store.state.investmentContract.id
    }
  }
}
</script>
